import { useEffect } from 'react'

import { applyDesign } from '@plugin-protocol'

import { resolveTheme, useUiStore } from '../../shared/hooks'

/** Applies light/dark (`data-theme`) and the visual theme (`data-design`, ADR-056) to the document. */
export function useThemeSync() {
  const theme = useUiStore((s) => s.theme)
  const design = useUiStore((s) => s.design)

  useEffect(() => {
    applyDesign(design)
  }, [design])

  useEffect(() => {
    const apply = () => {
      document.documentElement.dataset.theme = resolveTheme(theme)
    }

    apply()
    if (theme !== 'system') return
    const mq = window.matchMedia('(prefers-color-scheme: dark)')

    mq.addEventListener('change', apply)

    return () => mq.removeEventListener('change', apply)
  }, [theme])
}
